import type { ImageContent, VideoContent } from "$lib/elev8Api/contentTypes";

type ContentWithCallback = ImageContent | VideoContent;

/**
 * Extracts the proof-of-play URL from content object
 * @param content - Content object that may have a callback_url
 * @returns The callback URL or undefined if not present
 */
export function getPopUrl(content: ContentWithCallback): string | undefined {
  return content.callback_url;
}
